import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useFilterDrawerStore } from '../FilterDrawer/useFilterDrawerStore';
import { MarkerData } from '../../ClientDashboardV2';

import ClientMarkerList from './ClientMarkerList';

import { ObjectItem } from 'api/clients/types';

interface Props {
  appliedClientFilter: number[];
  markers: MarkerData[];
  handleZoomToMarker: (position: [number, number]) => void;
  handleSetOnMap: (obj: ObjectItem) => void;
  onClose?: () => void;
}

const ClientSidebar: React.FC<Props> = ({
  appliedClientFilter,
  markers,
  handleZoomToMarker,
  handleSetOnMap,
  onClose,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'ClientSidebar' });
  const { toggleFilterDrawer, setMarkers, activityFilter } = useFilterDrawerStore();

  useEffect(() => {
    setMarkers(markers);
  }, [markers, setMarkers]);

  const hasActiveFilters = appliedClientFilter.length > 0 || activityFilter !== null;

  return (
    <div
      className="card border rounded p-3 pt-0 overflow-auto"
      style={{ height: '70vh', maxHeight: '70vh', maxWidth: '400px', minWidth: '230px', width: '100%' }}
    >
      <div
        className="card-header align-items-center d-flex bg-white w-100"
        style={{ position: 'sticky', top: 0, zIndex: 1, padding: '16px 10px 16px 10px' }}
      >
        <h4 style={{ fontWeight: '700' }} className="card-title mb-0 flex-grow-1 text-break">
          {t('siteList')}
        </h4>

        <div className="d-flex align-items-center gap-2">
          <button className="rounded-4 btn btn-ghost-purple" onClick={toggleFilterDrawer}>
            <i className={`${hasActiveFilters ? 'ri-filter-fill' : 'ri-filter-line'} align-middle me-1 fs-15`} />
            {t('filter')}
          </button>

          {onClose && (
            <button
              onClick={onClose}
              className="rounded-pill btn btn-ghost-purple p-0 px-1"
              style={{ fontSize: '1.2rem' }}
            >
              <i className="ri-close-line" />
            </button>
          )}
        </div>
      </div>

      <div style={{ width: '100%' }}>
        <ClientMarkerList
          markers={markers}
          appliedClientFilter={appliedClientFilter}
          activityFilter={activityFilter}
          handleZoomToMarker={handleZoomToMarker}
          handleSetOnMap={handleSetOnMap}
        />
      </div>
    </div>
  );
};

export default ClientSidebar;
